<template>
  <ul v-if="alertes?.length" class="company-sante-alertes">
    <li v-for="alerte in alertes" :key="alerte.code" class="company-sante-alerte">
      <component
        :is="lien ? 'a' : 'span'"
        :href="lien || undefined"
        :target="lien ? '_blank' : undefined"
        :rel="lien ? 'noopener noreferrer' : undefined"
        class="company-sante-alerte__libelle"
      >
        <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
        {{ alerte.libelle }}
        <template v-if="lien">
          <i class="fas fa-external-link-alt company-sante-alerte__sortie" aria-hidden="true"></i>
          <span class="list-sr-only">(ouvre la fiche Pappers dans un nouvel onglet)</span>
        </template>
      </component>
      <span v-if="alerte.depuis" class="company-sante-alerte__depuis">
        depuis le {{ formatDate(alerte.depuis) }}
      </span>
    </li>
  </ul>
</template>

<script setup>
import { computed } from 'vue'
import { formatDate } from '../../utils/dateFormatters.js'
import { pappersUrl } from '../../utils/companySante.js'

/**
 * Les alertes d'une entreprise, écrites comme Pappers les écrit
 * (« ⚠ Plan de sauvegarde en cours »). Chacune ouvre la fiche Pappers : c'est
 * là que le commercial va lire le détail — jugements, contentieux, comptes —
 * que le BODACC seul ne donne pas.
 */
const props = defineProps({
  alertes: { type: Array, default: null },
  siret: { type: String, default: null }
})

const lien = computed(() => pappersUrl(props.siret))
</script>

<style scoped>
.company-sante-alertes {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  margin: 0;
  padding: 0;
  list-style: none;
}

.company-sante-alerte {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--spacing-2);
}

/* En ligne, pas en flex : dans une colonne étroite l'alerte se replie comme
   une phrase, pictogrammes compris, au lieu de rejeter la flèche au bord. */
.company-sante-alerte__libelle {
  color: var(--pill-warning-fg);
  font-weight: 600;
  text-decoration: none;
}

.company-sante-alerte__libelle .fa-exclamation-triangle {
  margin-right: var(--spacing-1);
}

a.company-sante-alerte__libelle:hover,
a.company-sante-alerte__libelle:focus-visible {
  text-decoration: underline;
}

.company-sante-alerte__sortie {
  margin-left: var(--spacing-1);
  font-size: 0.75em;
  opacity: 0.7;
}

.company-sante-alerte__depuis {
  color: var(--color-text-tertiary);
  font-size: 0.85em;
}
</style>
